"use client";

import Link from "next/link";
import Image from "next/image";
import GamesSearchAndCarousel from "./games/gamesSearchAndCaruselWrapper";
import HPLatestApps from "./homepage/latest-apps";
import PageViewTracker from "./PageViewTracker";
import SearchNotFound from "./search/searchNotFound";
import { useAppContext } from "/context/app-context";
import { ServerToClientProps } from "../utils/model";
import Error from "/app/error";

const NotFoundError = ({ data }: ServerToClientProps) => {
  let activePlatform = "unknown";
  
  try {
    const { device } = useAppContext();
    activePlatform = device.os;
  } catch (error) {
    console.warn("NotFoundError: AppContext not available, using defaults");
  }
  return (
    <>
      <PageViewTracker />
      <div className="text-center mb-10">
        <div className="hero-image flex flow-col items-center justify-center gap-4">
          <Image
            alt="404 Not Found"
            src="/404-not-found.webp"
            className="max-w-[300px] w-full"
            placeholder="blur"
            blurDataURL="/404-not-found-blur.webp"
            sizes="100vw"
            width={0}
            height={0}
            style={{ maxWidth: "300px", width: "auto", height: "auto" }}
          />
          <h2 className="text-xl">
            <span className="text-[70px] uppercase">404 Error!</span>
            <br />
            The page you are looking for does not exist.
          </h2>
        </div>
      </div>

      {/* <div className="container px-1 sm:px-0 w-full mx-auto my-8">
        <div className="flex items-center w-full">
          <SearchNotFound />
        </div>
      </div>
     
      <div className="container px-1 sm:px-0 w-full mx-auto my-8">
        <div className="w-full justify-between border-b-slate-400 border-b py-2 mb-2">
          <h2 className="text-xl uppercase font-medium">
            PLAY GAMES ON GETJAR
          </h2>
        </div>
        <GamesSearchAndCarousel
          games={data.data}
          showSearch={false}
        ></GamesSearchAndCarousel>
      </div> */}
    </>
  );
};
export default NotFoundError;
